import styled from 'styled-components';
import { ReactNode } from 'react';
import { DarkModeProvider } from '../../contexts/DarkModeContext';
import { LanguageProvider } from '../../contexts/LanguageContext';

interface ILayoutProps {
  children: ReactNode;
}

const Layout = (props: ILayoutProps) => {
  return (
    <DarkModeProvider>
      <LanguageProvider>
        <Container>
          <Inner>
            {/* <Header /> */}
            <Body>{props.children}</Body>
          </Inner>
        </Container>
      </LanguageProvider>
    </DarkModeProvider>
  );
};
export default Layout;

//style
const Container = styled.div`
  height: 100vh;
`;

const Inner = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 30rem auto;
  @media screen and (max-width: 1400px) {
    grid-template-rows: 25.5rem auto;
  }
  @media screen and (max-width: 640px) {
    grid-template-rows: 10rem auto;
  }
`;

const Body = styled.main`
  align-self: stretch;
`;
